import React, { useEffect, useState, useCallback } from 'react';
import Slider from '../../Components/Slider/Slider';
import Campaigns from '../../Components/Campaigns/Campaigns';
import { getComponent } from '../../ComponentsMap';
import Image from '../../Assets/Images/Screenshot (2157).png';
import Child from '../../Assets/Images/Child.webp';
import Image2 from '../../Assets/Images/sunset.jpg';
import Vector from '../../Assets/Images/Donate.svg';
import { createSliderInstance } from '../../Models/Slider';
import { createMediaGalleryInstance } from '../../Models/MediaGallery';
import { toast } from 'react-toastify';
import { CampaignService } from '../../Services/Axios/Api';
import StaticSection1 from './StaticSection1';
import { Col, Container, Row } from 'react-bootstrap';
import BJSpinner from '../../Components/Loader/BJSpinner';
import { getCurrentTenant } from '../../Services/Axios/axiosInstance';
import { useTranslation } from 'react-i18next';
import { createDonationCardInstance } from '../../Models/DonationCard';

const Home = () => {
  const { i18n } = useTranslation();
  const [sliderInstance, setSliderInstance] = useState(createSliderInstance());
  const [sliderData, setSliderData] = useState(null);
  const [galleryInstance, setGalleryInstance] = useState(createMediaGalleryInstance());
  const [galleryData, setGalleryData] = useState(null);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [campaignsLoading, setCampaignsLoading] = useState(true);
  const [campaignsData, setCampaignsData] = useState(null);
  const [donationCardInstance, setDonationCardInstance] = useState(createDonationCardInstance());
  const [currentData, setCurrentData] = useState(donationCardInstance.getData());
  const [NormalDisplay, setNormalDisplay] = useState('normal');
  const [ProgressingDisplay, setProgressingDisplay] = useState('normal');
  const [normalAnimation, setNormalAnimation] = useState(null);
  const [progressingAnimation, setProgressingAnimation] = useState(null);
  // Get current language from i18n
  const currentLanguage = i18n.language;

  // Memoized function to load slider data
  const loadSliderData = useCallback(async (language) => {
    try {
      console.log('Home: Loading slider data for language:', language);
      await sliderInstance.loadByLanguage(language);
      setSliderData(sliderInstance.getData());
    } catch (error) {
      console.error('Error loading slider data:', error);
      // Fallback to default data if loading fails
      const defaultData = {
        slides: [
          {
            id: 1,
            image: Child,
            title: "first slide",
            caption: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officiis eaque, cumque minima blanditiis beatae, aliquam repellendus laudantium similique hic quae eum? Autem consequuntur similique iusto, laudantium aut molestiae illo amet!`,
            buttons: [
              {
                id: 1,
                type: "button",
                button: {
                  text: 'تبرع الان',
                  link: '/donations',
                  type: 'link',
                  buttonType: 'primary',
                  className: 'SliderBtn',
                  style: {
                    "border-radius": '25px',
                  },
                }
              }
            ],
            order: 1
          },
          {
            id: 2,
            image: Image2,
            title: "second slide",
            caption: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officiis eaque, cumque minima blanditiis beatae, aliquam repellendus laudantium similique hic quae eum? Autem consequuntur similique iusto, laudantium aut molestiae illo amet!`,
            buttons: [],
            order: 2
          }
        ],
        style: {
          SlideTitle: { color: "#ffffff" },
          SlideCaption: { color: "#ffffff" }
        }
      };
      setSliderData(defaultData);
    }
  }, [sliderInstance]);

  // Memoized function to load gallery data
  const loadGalleryData = useCallback(async (language) => {
    try {
      console.log('Home: Loading gallery data for language:', language);
      setGalleryLoading(true);
      await galleryInstance.loadByLanguage(language);
      setGalleryInstance(galleryInstance);
      setGalleryData(galleryInstance.getData());
    } catch (error) {
      console.error('Error loading gallery data:', error);
      toast.error('Failed to load gallery data');
    } finally {
      setGalleryLoading(false);
    }
  }, [galleryInstance]);

  // Handle language change from i18n
  const handleLanguageChange = useCallback((newLanguage) => {
    loadSliderData(newLanguage);
    loadGalleryData(newLanguage);
  }, [loadSliderData, loadGalleryData]);

  useEffect(() => {
    loadSliderData(currentLanguage);
    loadGalleryData(currentLanguage);
  }, [loadSliderData, loadGalleryData, currentLanguage]);

  // Listen for language changes
  useEffect(() => {
    const handleLanguageChangeEvent = () => {
      loadSliderData(i18n.language);
      loadGalleryData(i18n.language);
    };

    i18n.on('languageChanged', handleLanguageChangeEvent);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChangeEvent);
    };
  }, [i18n, loadSliderData, loadGalleryData]);

  useEffect(() => {
    const loadCampaignsData = async () => {
      try {
        setCampaignsLoading(true);
        const response = await CampaignService.getActiveCampaigns();
        setCampaignsData(response.result);
        console.log("campaigns", response);
      } catch (error) {
        toast.error('Failed to load campaigns data');
        console.error('Error loading campaigns:', error);
      } finally {
        setCampaignsLoading(false);
      }

    };

    loadCampaignsData();
  }, []);
  
  useEffect(() => {
    // ensure animations are refreshed after both campaigns and animations are set
    // using aosLite from app
    try {
      // optional if refreshAosLite is globally available
      const { refreshAosLite } = require('../../Services/Animations/aosLite');
      refreshAosLite && refreshAosLite();
    } catch (e) {}
  }, [campaignsData, normalAnimation, progressingAnimation]);
  useEffect(() => {
    loadDonationCardData();
  }, []);

  const loadDonationCardData = async () => {
    try {
      await donationCardInstance.load();
      setCurrentData(donationCardInstance.getData());
      donationCardInstance.renderStyles();
      setNormalDisplay(donationCardInstance.getNormalCardDisplay());
      setProgressingDisplay(donationCardInstance.getProgressingCardDisplay());
      setNormalAnimation(donationCardInstance.getNormalAnimation());
      setProgressingAnimation(donationCardInstance.getProgressingAnimation());
    } catch (error) {
      console.error('Error loading donation card data:', error);
    }
  };
  const TwoColData = {
    title: 'Hello Two Col Section',
    text: `Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus quo amet modi magni. Quasi doloremque iste quibusdam fugiat nisi vero dolore sequi ab laborum. Adipisci enim quisquam deserunt accusamus officiis.`,
    image: Vector,
  };

  return (
    <>
      <BJSpinner isLoading={campaignsLoading} text="Loading..." color="#2B7CD3" />

      {sliderData && sliderInstance.getIsVisible() && (
        <Slider
          slides={sliderData.slides}
          style={sliderData.style}
          animation={sliderData.animation}
          containerType={sliderData.containerType}
        />
      )}
      {getCurrentTenant() === "tenant-1" && (
        <StaticSection1 />
      )}

      <div className="container mt-5 mb-5">
        <div className="row">
          {campaignsData?.map(row => ({
            ...row,
            campaigns: row.campaigns?.filter(c => c.isVisible !== false)
          })).filter(row => row.campaigns?.length > 0).slice(0, 2).map((row) => (
            <>
              <div className="Center mb-3 mt-3">
                <h1>{row?.section?.name}</h1>
              </div>
              {row?.campaigns?.map((row2) => {
                const newRow = { ...row2, display: row2.campaignSection.mode === 'Normal' ? NormalDisplay: ProgressingDisplay };  
                if (row2.campaignSection.mode === 'Normal') {
                  return getComponent('NormalDonationCard', { ...newRow, animation: normalAnimation });
                } else {
                  return getComponent('ProgressingDonationCard', { ...newRow, animation: progressingAnimation });
                }
              })}
            </>
          ))}
        </div>
      </div>
      {/* <div className="mt-5 mb-5">
                {getComponent('TwoColSection', TwoColData)}
            </div> */}
      {
        galleryData && galleryInstance.isVisible() && (
          <div className="mt-5 mb-5">
            {getComponent(galleryInstance.getMode() === 'carousel' ? 'Carousel' : 'MediaGallery', {
              title: galleryData?.title,
              images: galleryData?.images,
              animation: galleryData?.animation,
            })}
          </div>
        )
      }

      {getCurrentTenant() === "tenant-1" && (
        <section className="about-closing mt-5">
          <div className="about-closing-title text-center mb-5">
            <h1>Contact Us</h1>
          </div>
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} className="text-center">
                <p className="about-closing-text">
                  At Sanad, we believe in the power of connection and communication. Our dedicated team is here to listen, assist, and guide you through any questions or concerns you may have. Whether you're looking to make a donation, volunteer, or simply learn more about our initiatives, we're here to help.
                </p>
                <p className="about-closing-text">
                  Reach out to us through our contact form, email, or phone, and we'll get back to you as soon as possible. Your voice matters to us, and we're committed to building meaningful relationships with our supporters and partners.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </>

  );
}

export default Home;